import { notification } from 'antd';
import excel from 'exceljs';
import axios from 'axios';
import dayjs from 'dayjs';

export function newObjectKeys(originalObject, necessaryKeys) {
  return Object.fromEntries(
    Object.entries(originalObject)
      .filter(([key, value]) => necessaryKeys.includes(key))
      .map(([key, value]) => [key, value])
  );
}

export async function uploadImageCDN(file, token) {
  const FILE_UPLOAD = process.env.REACT_APP_UPLOAD_FILE_API_ENDPOINT;
  const data = new FormData();
  data.append('files', file);
  data.append('token', token);
  const response = await axios
    .post(FILE_UPLOAD, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  if (response?.data?.status) {
    return response.data?.path;
  } else {
    notification.error({
      message: response?.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại!',
    });
  }
}

export const ConvertData = (data) => {
  try {
    if (!data) {
      return [];
    }

    return data?.map((item) => ({
      ...item,
      label: item.name || ' ',
      value: +item.id,
    }));
  } catch (error) {
    console.log(error);
  }

  return [];
};

export const ConvertDataName = (data) => {
  try {
    if (!data) {
      return [];
    }

    return data?.map((item) => ({
      ...item,
      label: item.name,
      value: item.name,
    }));
  } catch (error) {
    console.log(error);
  }

  return [];
};

export const formatNumber = (value) => {
  if ((value == null || value == undefined || value == '') && (value != 0 || value != '0')) {
    return '';
  }
  if (!isNaN(value)) {
    return Number(value).toLocaleString('de-DE');
  }
  return value.toString();
};

export function isNumber(value) {
  if (!value) {
    return false;
  }

  // Loại bỏ các dấu phân cách hàng nghìn nếu có
  const cleanedValue = value
    .toString()
    .replace(/%/g, '')
    .replace(/,/g, '')
    .replace(/(?<=\d)\./g, '')
    .trim();
  // Kiểm tra xem giá trị đã được làm sạch có phải là số không
  return !isNaN(cleanedValue);
}

export function toNumber(value) {
  if (!value) {
    return value;
  }

  let cleanedValue = value.toString().replace(/%/g, '').replace(/\./g, '').trim();

  if (cleanedValue.includes(',')) {
    cleanedValue = cleanedValue.replace(',', '.');
  }

  const numberValue = parseFloat(cleanedValue);
  return isNaN(numberValue) ? null : numberValue;
}

export function removeNullValues(obj) {
  if (Array.isArray(obj)) {
    // Nếu là mảng, lặp qua từng phần tử và lọc đệ quy
    return obj.map(removeNullValues).filter((item) => item !== null);
  } else if (obj !== null && typeof obj === 'object') {
    // Nếu là đối tượng, lọc các trường có giá trị null
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, value]) => value !== null) // Loại bỏ các trường có giá trị null
        .map(([key, value]) => [key, removeNullValues(value)]) // Lọc đệ quy
    );
  }
  // Nếu không phải mảng hay đối tượng, trả về giá trị gốc
  return obj;
}

export const dataToOptionSelect = (data, label = 'name', value = 'id') => {
  return data?.map((item) => ({
    label: item[label],
    value: item[value],
    disabled: item.disabled || false,
  }));
};

export const exportTableToExcelNew = (data, filename = '') => {
  let workbook = new excel.Workbook();
  let worksheet = workbook.addWorksheet(`${dayjs().format('DD-MM-YYYY')}`);

  data.data = data.data.map((item) => {
    const { type, id, key, ...rest } = item;
    return rest;
  });

  worksheet.columns = Object.keys(data.data[0]).map((key) => ({
    header: key,
    key: key,
    width: 20,
  }));

  for (let i = 0; i < data.data.length; ++i) {
    const statistic = data.data[i];
    let rowExcel = {};
    Object.keys(statistic).map((key) => {
      rowExcel = Object.assign(rowExcel, {
        [key]: statistic[key],
      });
    });

    worksheet.addRows([rowExcel]);
  }

  let rowExcel = {};

  rowExcel[worksheet.getCell('A1').value] = 'Tổng';

  for (const dataRow of data.fixedColumns) {
    rowExcel = Object.assign(rowExcel, {
      [dataRow['name']]: formatNumber(dataRow['value']),
    });
  }

  worksheet.addRows([rowExcel]);
  let lastRowIndex = worksheet.rowCount;
  let endColumnLetter = String.fromCharCode('A'.charCodeAt(0) + data.colSpan - 1);
  worksheet.mergeCells(`A${lastRowIndex}:${endColumnLetter}${lastRowIndex}`);

  workbook.xlsx
    .writeBuffer()
    .then((buffer) => {
      let blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename ?? 'output'}.xlsx`; // Tên file muốn lưu
      document.body.appendChild(a);
      a.click();
      a.remove(); // Sau khi tải về, xóa element a khỏi DOM
    })
    .catch((error) => {
      console.error('Error writing file:', error);
    });
};
